// api-core refuses every agent status change while the agent has an open Shared Power Dialer
// session (UserController::SPD_SESSION_OPEN_REFUSAL_CODE); ending the session is the way out.
export const SPD_SESSION_OPEN_REFUSAL_CODE = 'spd_session_open'

// Answered with the held status and a reason to show; retrying cannot land.
export function isSpdSessionOpenRefusal (err) {
  return err?.response?.status === 409 && err?.response?.data?.code === SPD_SESSION_OPEN_REFUSAL_CODE
}
